export default "__VITE_ASSET__BCCXEGbn__"